import { gql } from "@apollo/client";

export const GET_PAYMENT_INTENT = gql`
  mutation GetPaymentIntent($amountCents: PositiveInt!, $collectionId: String!) {
    getPaymentIntent(amountCents: $amountCents, collectionId: $collectionId)
  }
`;
